export const DROPDOWN_ALIGN = {
  topLeft: 'top-left',
  topRight: 'top-right',
  topCenter: 'top-center',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right',
  bottomCenter: 'bottom-center',
} as const;
export type DropdownAlign = (typeof DROPDOWN_ALIGN)[keyof typeof DROPDOWN_ALIGN];
